import React from 'react'
import { Link } from 'react-router-dom'
import Constant from '../../../Constant'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import 'react-toggle/style.css' // for ES6 modules
import Toggle from 'react-toggle'
import axios from 'axios'
import ActivitiesController from '../../../common/activitiesController/ActivitiesController'
import Moment from 'react-moment'

class PackageList extends React.Component {
  state = {
    data: [],
  }
  componentDidMount() {
    if (this.props?.match?.params?.source_id) {
      this.getData(this.props.match.params.source_id)
    }
  }

  getData = async (id) => {
    var that = this

    await axios
      .get(Constant.getAPI() + `/chalet/list-package/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          that.setState({
            data: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  deleteItem = (id) => {
    var token = `Bearer ${localStorage.getItem('loged_In_auth')}`

    axios
      .delete(Constant.getAPI() + `/chalet/delete-package/${id}`, {
        headers: { Authorization: token, country_short_name: `${localStorage.getItem('countryShortName')}` },
      })
      .then(() => {
        Swal.fire({
          title: 'Package Deleted Successfully!',
          icon: 'success',
          text: '',
          type: 'success',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        })
        this.getData(this.props?.match?.params?.source_id)
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleStatusChange = async (id, isActive, type) => {
    var data = { id }

    if (type == 'block_dates_from_other_packages') {
      data.block_dates_from_other_packages = isActive
    } else if (type == 'is_flash_offer') {
      data.is_flash_offer = isActive
    } else {
      data.is_active = isActive
    }

    await axios
      .put(Constant.getAPI() + '/chalet/update-package', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Updated !', 'Status has been Changed', 'success')
          this.getData(this.props?.match?.params?.source_id)
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  render() {
    const columns = [
      {
        name: 'order',
        label: 'Order',
        options: {
          customBodyRender: (data) => {
            return data || '--'
          },
        },
      },
      {
        name: 'name_en',
        label: 'Name: English',
      },
      {
        name: 'name_ar',
        label: 'Name: Arabic',
      },
      {
        name: 'price',
        label: 'Price',
      },
      {
        name: 'created_at',
        label: 'Creation Date',
        options: {
          customBodyRender: (value) =>
            value ? (
              <div style={{ textWrap: 'nowrap' }}>
                <Moment format="YYYY-MM-DD">{value}</Moment>
              </div>
            ) : (
              '--'
            ),
        },
      },
      {
        name: 'is_flash_offer',
        label: 'Flash Offer',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (isActive, tableMeta) => {
            const id = tableMeta.rowData[tableMeta.rowData.length - 1]
            return (
              <Toggle
                id={id}
                checked={isActive}
                value={isActive + ''}
                onChange={this.handleStatusChange.bind(this, id, !isActive, 'is_flash_offer')}
              />
            )
          },
        },
      },
      {
        name: 'is_active',
        label: 'Status',
        options: {
          customBodyRender: (isActive, tableMeta) => {
            const id = tableMeta.rowData[tableMeta.rowData.length - 1]
            return (
              <Toggle
                id={id}
                checked={isActive}
                value={isActive + ''}
                onChange={this.handleStatusChange.bind(this, id, !isActive)}
              />
            )
          },
        },
      },
      {
        name: 'block_dates_from_other_packages',
        label: 'Block Dates - Package booking',
        options: {
          customBodyRender: (isActive, tableMeta) => {
            const id = tableMeta.rowData[tableMeta.rowData.length - 1]
            return (
              <Toggle
                id={id}
                checked={isActive}
                value={isActive + ''}
                onChange={this.handleStatusChange.bind(this, id, !isActive, 'block_dates_from_other_packages')}
              />
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Actions',
        options: {
          customBodyRender: (id) => {
            return (
              <div style={{ display: 'flex' }}>
                <Link
                  to={`/chalet-package/add/${this.props?.match?.params?.source_id}/` + id}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Edit"
                >
                  <i className="f-20 icofont icofont-ui-edit text-custom"></i>
                </Link>
                <span
                  onClick={this.deleteItem.bind(this, id)}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Delete"
                >
                  <i className="f-20 icofont icofont-delete-alt text-danger"></i>{' '}
                </span>
                <ActivitiesController refId={id}>Activities</ActivitiesController>
              </div>
            )
          },
        },
      },
    ]
    const options = {
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: false,
      selectableRows: 'none',
      search: false,
      filter: false,
      textLabels: {
        body: {
          noMatch: this.state.isSaving ? 'Loading data..!' : 'Sorry, No Data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }
    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Package List</h4>
                    </div>
                  </div>
                  <Link
                    to={`/chalet-package/add/${this.props?.match?.params?.source_id}`}
                    className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger"
                    data-modal="modal-13"
                  >
                    {' '}
                    <i className="icofont icofont-plus m-r-5"></i> Add Package
                  </Link>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item">
                        <Link to={`/chalet-details/${this.props?.match?.params?.source_id}`}>
                          <i className="feather">Chalet Details</i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Package List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        <MUIDataTable
                          className="table-responsive"
                          data={this.state.data}
                          columns={columns}
                          options={options}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default PackageList
